/**
 * Shared UI types (`Job`, `JobStatus`, `Entity`), plus the last piece of
 * prototype data: a hardcoded `ENTITIES` list that a few screens still
 * use for their entity pickers. New code should call `useEntities()`.
 *
 * The job simulator, fictional patients, users and workflows that used
 * to live here are gone; nothing reads them.
 */

export interface Entity {
  id: string;
  name: string;
  full: string;
}

export interface Workflow {
  id: string;
  name: string;
  portal: string;
}

export interface Patient {
  name: string;
  mrn: string;
}

export interface User {
  id: string;
  name: string;
  initials: string;
  role: string;
}

export type JobStatus =
  | "running"
  | "approval"
  | "takeover"
  | "failed"
  | "success"
  | "human"
  | "queued";

export interface Job {
  id: string;
  workflow: Workflow;
  entity: Entity;
  patient: Patient | null;
  user: User;
  status: JobStatus;
  /** The status exactly as the API sent it (`waiting_for_human`, …). Absent on mock jobs. */
  apiStatus?: string;
  curPhase: number;
  phases: string[];
  /** Runner seconds, computed by the API from real start/end times. */
  elapsed: number;
  /** Display string. The API falls back to the queue time here. */
  started: string;
  /** Real start time. `null` = never picked up by a runner. Absent on mock jobs. */
  startedAt?: string | null;
  /** Real end time. `null` = not finished. Absent on mock jobs. */
  completedAt?: string | null;
  resultSummary: string;
}

export const ENTITIES: Entity[] = [
  { id: "laoss", name: "LAOSS", full: "LA Orthopedic Surgery Specialists" },
  { id: "spineone", name: "SpineOne", full: "SpineOne Clinic" },
  { id: "mro", name: "MRO", full: "Musculoskeletal & Rehab Orthopedics" },
  { id: "nes", name: "NES", full: "Neurosurgery & Endocrine Specialists" },
];
